<template>
  <div style="margin: 0;">
    <div>
      <v-switch label="Allow Promo" :value="true" class="mb-3" :input-value="allowPromo"
                @change="$emit('update:allowPromo', $event)" />
      <component :is="promoComponent" v-if="promoComponent" :promo-item="promoItem" />
      <v-alert v-else dense outlined type="info">
        No promotion info available.
      </v-alert>
    </div>
  </div>
</template>

<script>
import B1g1 from './promo-types/B1g1.vue'
import B1gx from './promo-types/B1gx.vue'
import X4y from './promo-types/X4y.vue'
import CrossFreebie from './promo-types/v2/CrossFreebie.vue'
import PctDisc from './promo-types/PctDisc.vue'
import FixDisc from './promo-types/FixDisc.vue'

export default {
  components: {
    B1g1,
    B1gx,
    X4y,
    CrossFreebie,
    PctDisc,
    FixDisc,
  },
  props: {
    supplierProduct: { type: Object, required: true },
    promoItem: { type: Object, default: null },
    allowPromo: Boolean,
  },
  computed: {
    promoComponent() {
      const code = this.promoItem?.typeCode
      if (!code) return null
      console.log('component', {
        b1g1: 'B1g1',
        b1gx: 'B1gx',
        x4y: 'X4y',
        cross_freebie: 'CrossFreebie',
        pct_disc: 'PctDisc',
        fix_disc: 'FixDisc',
      }[code])
      return {
        b1g1: 'B1g1',
        b1gx: 'B1gx',
        x4y: 'X4y',
        cross_freebie: 'CrossFreebie',
        pct_disc: 'PctDisc',
        fix_disc: 'FixDisc',
      }[code] || null
    },
  },
}
</script>